<template>
  <div>
    <div v-if="dataLoaded">
      <div v-if="rules.rule120Days.ruleApplies">
        {{rules.rule120Days.workDayCount}}/{{rules.rule120Days.relativeAllowedWorkDays}} Arbeitstage dieses Jahr
      </div>
      <div v-if="rules.rule26Weeks.ruleApplies">
        {{rules.rule26Weeks.weekCount}}/26 in den letzten 52 Wochen mit über 20 Stunden
      </div>
    </div>
    <div v-else>
      ...
    </div>
  </div>
</template>

<script>
  import axios from "axios";


  export default {
    name: "userRuleApplication",
    props: ['user'],
    data: function () {
      return {
        rules: {},
        dataLoaded: false
      }
    },
    created: function () {
    },
    methods: {
    },
    mounted() {
      //Load users
      axios({ method: "GET", url: process.env.VUE_APP_API_PATH+"rules/GetAppliedRules?userId=" + this.user.id }).then(result => {
        this.rules = result.data;
        this.dataLoaded = true;
      }, error => {
        console.error(error);
        if (error.response.status == 401) {
          this.$router.push("/");
        }
      });
    }
  };
</script>
